import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth, type AuthState } from "@/hooks/use-auth";
import { PassphraseDialog } from "./PassphraseDialog";

export function AuthScreen() {
  const { state, error, startAuth, submitPassphrase, setupPassphrase } =
    useAuth();
  const [loading, setLoading] = useState(false);

  const handleGetStarted = async () => {
    setLoading(true);
    try {
      await startAuth();
    } finally {
      setLoading(false);
    }
  };

  if (state === "needs-passphrase") {
    return (
      <PassphraseDialog
        mode="unlock"
        error={error}
        onSubmit={submitPassphrase}
      />
    );
  }

  if (state === "needs-setup") {
    return (
      <PassphraseDialog
        mode="setup"
        error={error}
        onSubmit={setupPassphrase}
      />
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-8">
      <div className="text-center max-w-sm">
        <h1 className="text-5xl font-bold text-on-surface mb-2">Brief</h1>
        <p className="text-lg text-outline mb-10">A chat with yourself.</p>
        <Button
          onClick={handleGetStarted}
          disabled={loading}
          className="w-full h-14 text-lg rounded-2xl bg-primary text-primary-foreground hover:bg-primary/90"
        >
          {loading ? (
            <span className="inline-block w-5 h-5 border-2 border-primary-foreground/30 border-t-primary-foreground rounded-full animate-spin" />
          ) : (
            "Get Started"
          )}
        </Button>
        {error && (
          <p className="mt-4 text-sm text-destructive">{error}</p>
        )}
      </div>
    </div>
  );
}
